import { useState, useEffect } from 'react'
import { FranchiseService } from '../services/franchiseService'
import { FranchiseData } from '../config/api'

export const useFranchiseData = () => {
  const [franchiseData, setFranchiseData] = useState<FranchiseData | null>(null)
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState<string | null>(null)

  useEffect(() => {
    const fetchFranchiseData = async () => {
      try {
        setLoading(true)
        const service = FranchiseService.getInstance()
        const data = await service.getFranchiseData()
        setFranchiseData(data)
        
        // Apply dynamic styles
        service.applyDynamicStyles(data)
        
        // Update document title
        document.title = `${data.name} - Travel & Holiday Packages`
        
        setError(null)
      } catch (err) {
        setError(err instanceof Error ? err.message : 'Failed to fetch franchise data')
      } finally {
        setLoading(false)
      }
    }

    fetchFranchiseData()
  }, [])

  return { franchiseData, loading, error }
} 